import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {ButtonComponent} from "../../buttons/button/button.component";
import {ButtonConnotation, ButtonProminence, ButtonTier} from "../../buttons/button/button";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {SelectorControlComponent} from '../../inputs/selector-control/selector-control.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

export class ButtonSpec {
    label: string;
    connotation: ButtonConnotation;
    result?: any;
}

export class CheckboxSpec {
    label: string;
    name: string;
    checked: boolean;
}

@Component({
    selector: "woa-simple-dialog-page",
    templateUrl: "simple-dialog-page.component.html",
    styleUrl: "./simple-dialog-page.component.scss",
    providers: [{provide: Page, useExisting: SimpleDialogPageComponent}],
    imports: [
        ButtonComponent,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        SelectorControlComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleDialogPageComponent extends Page {
    ButtonTier = ButtonTier;
    ButtonProminence = ButtonProminence;
    ButtonConnotation = ButtonConnotation;

    public readonly showHeader: Signal<boolean> = navParam<boolean>("showHeader", true);
    public readonly showCloseButton: Signal<boolean> = navParam<boolean>("showCloseButton", true);
    public readonly title: Signal<string> = navParam<string>("title");
    public readonly subtitle: Signal<string> = navParam<string>("subtitle");
    public readonly translationParams: Signal<Record<string, string | number>> = navParam<Record<string, string | number>>("translationParams");
    public readonly contentText: Signal<string> = navParam<string>("contentText");
    public readonly popHistoryOnDismissal: Signal<boolean> = navParam<boolean>("popHistoryOnDismissal", true);
    public readonly buttons: Signal<ButtonSpec[]> = navParam<ButtonSpec[]>("buttons", []);
    public readonly checkboxes: Signal<CheckboxSpec[]> = navParam<CheckboxSpec[]>("checkboxes", []);

    public checkboxState: { [name: string]: boolean } = {};

    constructor() {
        super();
        this.checkboxes().forEach((checkbox: CheckboxSpec) => this.checkboxState[checkbox.name] = checkbox.checked || false);
    }

    async buttonSelected(result?: any): Promise<void> {
        this.checkboxes().forEach((checkbox: CheckboxSpec) => checkbox.checked = this.checkboxState[checkbox.name]);
        void this.dismiss(typeof result === "function" ? result(this.checkboxState) : result, false, this.popHistoryOnDismissal());
    }
}
